import { PayloadAction, createSlice } from "@reduxjs/toolkit"
import { Pagination } from "../../../types/Pagination"
import { RootState } from "../../app/store"

export interface MaterialTypeState {
  pagination: Pagination
  query: string
}

const initialState: MaterialTypeState = {
  pagination: {
    page: 0,
    size: 10,
  },
  query: "",
}

export const materialtypeSlice = createSlice({
  name: "materialType",
  initialState,
  reducers: {
    setMaterialTypePagination: (state, action: PayloadAction<Pagination>) => {
      state.pagination = {
        ...state.pagination,
        ...action.payload,
      }
    },
    setMaterialTypeQuery: (state, action: PayloadAction<string>) => {
      state.query = action.payload
    },
  },
})
export const selectMaterialTypePagination = (state: RootState) =>
  state.materialType.pagination
export const selectMaterialTypeQuery = (state: RootState) =>
  state.materialType.query
export const { setMaterialTypePagination, setMaterialTypeQuery } =
  materialtypeSlice.actions
export default materialtypeSlice.reducer
